import { Component } from "../../components/base/Component";
import { ICfa } from "../../models/ICfa";
import { ComponentFactory } from "../../services/ComponentFactory";

export class SignatureDropClaimForm extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		if (this._element.tagName !== "FORM") {
			throw new Error(`Non-form element passed in, element: ${this._element}`);
		}

		const form = this._element as HTMLFormElement;
		this.applyValidationRules(form);
		form.addEventListener("submit", e => this.handleSubmission(e));

		if (this.getCustomShippingInput()) {
			this.handleCustomShippingEffect();
		}
	}

	private applyValidationRules(form: HTMLFormElement): void {
		const messages = this._element.dataset;
		const errorClass = "hasError";
		$(form).validate({
			errorClass: "hasError",
			errorPlacement: (error, element) => {
				error.appendTo(element.next(".error-container"));
			},
			highlight: element => {
				$(element).parent().addClass(errorClass);
			},
			messages: {
				CustomAddress: {
					required: messages.customAddressMsg ?? ""
				},
				SizeSelection: {
					required: messages.sizeSelectionMsg ?? ""
				}
			},
			rules: {
				CustomAddress: {
					required: "#custom:checked"
				},
				SizeSelection: {
					required: true
				}
			},
			unhighlight: element => {
				$(element).parent().removeClass(errorClass);
			}
		});
	}

	private handleSubmission(e: Event): void {
		if (!this.validate()) {
			e.preventDefault();
		}
	}

	private validate(): boolean {
		if (this._element) {
			return $(this._element).valid();
		}

		return false;
	}

	private handleCustomShippingEffect(): void {
		const customShippingDiv = ".custom-shipping";

		this._element?.addEventListener("change", () => {
			if (this.getCustomShippingInput()?.checked) {
				$(customShippingDiv).slideDown();
			} else {
				$(customShippingDiv).slideUp();
			}
		});
	}

	private getCustomShippingInput(): HTMLInputElement | null {
		return this._element.querySelector("#custom") || null;
	}
}

ComponentFactory.registerComponent(
	"signatureDropClaimForm",
	SignatureDropClaimForm
);
